import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective, ReactiveFormsModule, Validators} from '@angular/forms';
import {AccountService} from '../../../../services/account/account.service';
import {LoaderService} from '../../../../services/loader/loader.service';
import {SnackbarService} from '../../../../services/snackbar/snackbar.service';
import {FormError} from '../../../../tools/form-error/form-error';
import {FormErrorComponent} from '../../../layout/form-error/form-error.component';

@Component({
  selector: 'app-account',
  imports: [
    ReactiveFormsModule,
    FormErrorComponent
  ],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss'
})
export class AccountComponent implements OnInit {
  formPassword = new FormGroup({
    password: new FormControl('', [Validators.required]),
    passwordConfirm: new FormControl('', [Validators.required])
  });

  formPasswordError = new FormError();

  constructor(
    private loader: LoaderService,
    private snackbar: SnackbarService,
    private accountService: AccountService
  ) {
  }

  ngOnInit(): void {
    this.formPassword.get('password')?.setErrors({plop: true})
  }

  onPasswordSubmit(form: FormGroupDirective): void {
    this.formPasswordError.clearErrors();
    this.formPasswordError.setFormGroupErrors(this.formPassword);

    if (!this.formPassword.valid) {
      return;
    }

    const data: any = this.formPassword.value;

    this.loader.startLoading();
    this.accountService.changePassword(data.password).subscribe({
      next: () => {
        this.loader.stopLoading();
        this.snackbar.success('Your password has been updated successfully.')
        form.resetForm();
      },
      error: (error) => {
        this.formPasswordError.setApiResponseErrors(error);
      }
    });
  }
}
